import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
export const TabContainerContext = /*#__PURE__*/createContext(null);
export const TabContentContext = /*#__PURE__*/createContext(null);
export const NavbarContext = /*#__PURE__*/createContext(null);
export const useTabContainer = () => useContext(TabContainerContext);
export const useTabContent = () => useContext(TabContentContext);
export const useNavbar = () => useContext(NavbarContext);
export function TabContainerProvider(_ref) {
  let {
    value,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(TabContainerContext.Provider, {
    value: value,
    children: children
  });
}
export function TabContentProvider(_ref2) {
  let {
    value,
    children
  } = _ref2;
  return /*#__PURE__*/_jsx(TabContentContext.Provider, {
    value: value,
    children: children
  });
}
export function NavbarProvider(_ref3) {
  let {
    value,
    children
  } = _ref3;
  return /*#__PURE__*/_jsx(NavbarContext.Provider, {
    value: value,
    children: children
  });
}